class MegaMenuPanelContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.triggers = this.parentElement.querySelectorAll('[data-mega-menu-panel-trigger]');
    this.defaultPanel = this.querySelector('[data-mega-menu-panel="__default"]');
    this.wrapper = this.closest('.mega-menu__inner');
    this.mobileClose = this.querySelector('[data-mega-menu-panel-close]');
    this.activePanel = this.defaultPanel;
    this.lastTrigger = null;

    this.removeEvents = [];
    this.timeouts = [];

    this.handleTriggerClick = (e) => {
      this._clearTimeouts();
      const trigger = e.target;
      const targetPanel = this.querySelector(`[data-mega-menu-panel="${trigger.dataset.megaMenuPanelTrigger}"]`);

      this.lastTrigger = trigger;
      if (targetPanel === this.activePanel) {
        this._showDefaultPanel();
        return;
      }

      this._showPanel(targetPanel);
    };

    this.handleTriggerMouseEnter = (e) => {
      if (this._isMobile) return;
      this._clearTimeouts();

      const trigger = e.target;
      const targetPanel = this.querySelector(`[data-mega-menu-panel="${trigger.dataset.megaMenuPanelTrigger}"]`);
      if (targetPanel === this.activePanel) return;

      this._showPanel(targetPanel);
    };

    this.handleTriggerMouseLeave = () => {
      if (this._isMobile) return;
      if (this.activePanel === this.defaultPanel) return;

      const timeout = setTimeout(() => {
        this.timeouts = this.timeouts.filter(timeoutId => timeoutId !== timeout);

        if (this.activePanel === this.defaultPanel) return;

        this._showDefaultPanel();
      }, 500);

      this.timeouts.push(timeout);
    };

    this.triggers.forEach(trigger => trigger.addEventListener('click', this.handleTriggerClick));
    this.triggers.forEach(trigger => trigger.addEventListener('mouseenter', this.handleTriggerMouseEnter));
    this.triggers.forEach(trigger => trigger.addEventListener('mouseleave', this.handleTriggerMouseLeave))

    this.addEventListener('mouseleave', () => {
      if (this._isMobile) return;
      this._showDefaultPanel();
    });

    this.addEventListener('mouseenter', () => {
      if (this._isMobile) return;
      this._clearTimeouts();
    });

    this.handleMegaMenuClose = () => this._revert();
    document.addEventListener("mega-menu:closed", this.handleMegaMenuClose);

    this.mobileClose.addEventListener('click', () => this._hideMobilePanel());

    this.addEventListener("focusout", (e) => {
      if (!e.relatedTarget) return;
      if (this.contains(e.relatedTarget)) return;
      this._showDefaultPanel();
    });
  }

  disconnectedCallback() {
    this.triggers.forEach(trigger => trigger.removeEventListener('click', this.handleTriggerClick));
    this.triggers.forEach(trigger => trigger.removeEventListener('mouseenter', this.handleTriggerMouseEnter));
    this.triggers.forEach(trigger => trigger.removeEventListener('mouseleave', this.handleTriggerMouseLeave))

    document.removeEventListener("mega-menu:closed", this.handleMegaMenuClose);
  }

  _clearTimeouts() {
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }

  _revert() {
    this.activePanel.style.display = 'none';
    this.activePanel.style.opacity = null;
    this.activePanel.style.position = null;

    this.defaultPanel.style.display = null;
    this.defaultPanel.style.position = null;
    this.defaultPanel.style.opacity = null;

    this.wrapper.style.transform = null;

    this.activePanel = this.defaultPanel;
  }

  _showDefaultPanel() {
    if (this._isMobile) {
      this._hideMobilePanel();
    } else {
      this._showDesktopPanel(this.defaultPanel);
    }
  }

  _showPanel(panel) {
    if (this._isMobile) {
      this._showMobilePanel(panel);
    } else {
      this._showDesktopPanel(panel);
    }
  }

  _showMobilePanel(panel) {
    if (panel === this.activePanel) return;

    this.wrapper.removeEventListener('transitionend', this.onMobileOpenEnd);

    this.onMobileOpenEnd = () => {
      this.wrapper.removeEventListener('transitionend', this.onMobileOpenEnd);
      this.mobileClose.focus();
      this.activePanel = panel;
    };

    this.wrapper.addEventListener('transitionend', this.onMobileOpenEnd);
    panel.style.display = null;
    this.wrapper.style.transform = 'translateX(-100%)';
  }

  _hideMobilePanel() {
    this.wrapper.removeEventListener('transitionend', this.onMobileEnd);

    this.onMobileEnd = () => {
      this.wrapper.removeEventListener('transitionend', this.onMobileEnd);
      this.activePanel.style.display = 'none';
      this.activePanel = this.defaultPanel;
    };

    this.wrapper.addEventListener('transitionend', this.onMobileEnd);
    this.wrapper.style.transform = null;
    window.removeTrapFocus(this.lastTrigger);
  }

  _showDesktopPanel(panel) {
    if (panel === this.activePanel) return;

    this.removeEventListener('transitionend', this.onEnd);

    this.activePanel.style.position = 'absolute';
    this.activePanel.style.top = 0;
    panel.style.display = null;
    window.requestAnimationFrame(() => {
      panel.style.opacity = 1;
    });

    this.onEnd = () => {
      this.activePanel.style.display = 'none';
      this.activePanel.style.position = null;
      this.activePanel.style.top = null;
      this.removeEventListener('transitionend', this.onEnd);
      this.activePanel = panel;
    };

    this.addEventListener('transitionend', this.onEnd);

    this.activePanel.style.opacity = 0;
  }

  get _isMobile() {
    return !window.matchMedia("(min-width: 1280px)").matches;
  }
}

if (!customElements.get("mega-menu-panel-content")) {
  customElements.define("mega-menu-panel-content", MegaMenuPanelContent);
}
